<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.INBOX' | translate }}</h1>
                <br />
                <h4>{{ inboxEmail }}</h4>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>

<app-form-row>
    <app-form-group class="report-container">
        <app-table [loading]="loading" [clickable]="true">
            <tr thead>
                <app-table-header
                    [isActive]="sortKey === 'fileName'"
                    [defaultAscending]="sortKey === 'fileName' && sortAscending"
                    [sort]="true"
                    [dynamicWidth]="33"
                    [text]="'COLUMNS.NAME' | translate"
                    (sortChanged)="onSortChange('fileName', $event)"
                />
                <app-table-header
                    [isActive]="sortKey === 'from'"
                    [defaultAscending]="sortKey === 'from' && sortAscending"
                    [sort]="true"
                    [dynamicWidth]="33"
                    [text]="'COLUMNS.FROM' | translate"
                    (sortChanged)="onSortChange('from', $event)"
                />
                <app-table-header
                    [isActive]="sortKey === 'subject'"
                    [defaultAscending]="sortKey === 'subject' && sortAscending"
                    [sort]="true"
                    [dynamicWidth]="33"
                    [text]="'COLUMNS.SUBJECT' | translate"
                    (sortChanged)="onSortChange('subject', $event)"
                />
                <app-table-header
                    [isActive]="sortKey === 'created'"
                    [defaultAscending]="sortKey === 'created' && sortAscending"
                    [sort]="true"
                    [align]="align.Right"
                    [width]="14"
                    [text]="'COLUMNS.CREATED' | translate"
                    (sortChanged)="onSortChange('created', $event)"
                />
                <app-table-header
                    [align]="align.Center"
                    [width]="12"
                    *appHasPermissions="[permissions.WriteAgreement]"
                />
            </tr>
            <ng-container tbody>
                <tr *ngFor="let item of inbox$ | async" (click)="view(item)">
                    <td>{{ item.fileName }}</td>
                    <td>{{ item.from }}</td>
                    <td>{{ item.subject }}</td>
                    <td class="right">{{ item.created | dateTime: 'yyyy-MM-dd HH:mm' | replaceEmptyString }}</td>
                    <td class="center" *appHasPermissions="[permissions.WriteAgreement]">
                        <button
                            (click)="confirmDelete($event, item)"
                            class="icon"
                            [ngClass]="{ loading: loadingIds.includes(item.id) }"
                        >
                            <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                        </button>
                        <button
                            (click)="createAgreement($event, item)"
                            class="icon"
                            [ngClass]="{ loading: loadingIds.includes(item.id) }"
                        >
                            <span class="material-symbols-rounded" aria-label="Upload document"> upload </span>
                        </button>
                    </td>
                </tr>
            </ng-container>
        </app-table>
    </app-form-group>
    <div class="box">
        <app-form-group class="report-container">
            <ngx-extended-pdf-viewer
                class="pdf-viewer"
                #pdfViewer
                [src]="pdfByteArray"
                [showFindButton]="false"
                [showPagingButtons]="false"
                [showZoomButtons]="false"
                [showOpenFileButton]="false"
                height="100vh"
                useBrowserLocale="true"
                showSidebar="false"
                [textLayer]="true"
                zoom="auto"
            >
            </ngx-extended-pdf-viewer>
        </app-form-group>
    </div>
</app-form-row>
